var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSource = function SvgSource(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 28 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.344A19.182 19.182 0 00.875 9.167v16.041c5.075 0 9.683 1.97 13.125 5.178 3.442-3.194 8.05-5.178 13.125-5.178V9.167A19.182 19.182 0 0014 14.344zm0-5.177a4.37 4.37 0 004.375-4.375C18.375 2.37 16.421.417 14 .417S9.625 2.37 9.625 4.792A4.37 4.37 0 0014 9.167z",
    fill: "currentColor"
  })));
};
export default SvgSource;